
import { CustomElement, OverrideCustomElementConfig } from "@cervval.js/client-html5-core/src/components/customElement.decorator";
import { TypedHtmlElements } from "@cervval.js/client-html5-core/src/components/typedHtmlElements.decorator";
import { WebComponent } from "@cervval.js/client-html5-core/src/components/webComponent";
import "./borderLayout.dom.scss"; // *.dom.scss files are injected in html by style-loader

@CustomElement({
    name: "cjs-border-layout",
    style: require("./borderLayout.scss"),
    template: require("./borderLayout.html"),
    attachShadow: { mode: "open" }
})
export class CjsBorderLayout extends WebComponent {

    /**
     * BorderLayout constructor
     * When using from Javascript (ie not from html), you may not want to attach to shadow DOM and should pass { attachShadow: false }
     */
    constructor(options: { attachShadow: ShadowRootInit | false } & OverrideCustomElementConfig) {
        super(options);
    }

    @TypedHtmlElements({ refAttribute: "part", nearest: true })
    public readonly components!: {
        container: HTMLDivElement,
        top: HTMLDivElement,
        left: HTMLDivElement,
        center: HTMLDivElement,
        right: HTMLDivElement,
        bottom: HTMLDivElement
    };

}
